﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type UpdateFormCredentials = {
    type: "updateFormCredentials";
    newPassword: string;
};
type SetError = { type: "setError"; errorMessage: string };
type SetLoading = { type: "setLoading" };

export type SetPasswordViewAction =
    | UpdateFormCredentials
    | SetError
    | SetLoading;

interface SetPasswordState {
    newPassword: string;
    errorMessage: string;
    isLoading: boolean;
}

export function reducer<T>(
    state: SetPasswordState,
    action: SetPasswordViewAction
): SetPasswordState {
    switch (action.type) {
        case "updateFormCredentials": {
            return {
                ...state,
                newPassword: action.newPassword,
                errorMessage: null,
            };
        }
        case "setError": {
            return { ...state, errorMessage: action.errorMessage };
        }
        case "setLoading": {
            return { ...state, isLoading: true };
        }
    }
}
